import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import DynamicCrudPage from '../../components/DynamicCrudPage';
import { useFirmCards } from '../../hooks/useFirmCards';
import { SCREENS } from '../../constants/permissions';
import AddIcon from '@mui/icons-material/Add';

const CommunicationCardsPage = () => {
  const { firmId } = useParams();

  const transformFormData = useCallback(
    formData => {
      return {
        ...formData,
        firm_id: firmId,
      };
    },
    [firmId]
  );

  return (
    <DynamicCrudPage
      entityType="firm_cards"
      screen={SCREENS.FIRM_MANAGEMENTS}
      hook={useFirmCards}
      hookConfig={() => ({ firm_id: { _eq: firmId } })}
      additionalHooks={{}}
      addButtonTextKey="table.actions.addFirmCard"
      addButtonIcon={<AddIcon />}
      entityTypeForDataTable="firm_card"
      customTransformFormData={transformFormData}
      customTransformEditData={firmCardData => {
        if (!firmCardData) return {};
        return {
          ...firmCardData,
          firm_cart_status: firmCardData.firm_cart_status ? 'yes' : 'no',
        };
      }}
      showAddButton={true}
    />
  );
};

export default CommunicationCardsPage;
